import { useTranslation } from "react-i18next";
import OrderByHeaders from "components/ordering/OrderByHeaders";
import DateDisplay from "components/datetime/DateDisplay";

const TableAssetDevices = ({
    itemsShow,
    items,
    checkAll,
    setCheckAll,
    buttonsTB,
    setButtonsTB,
    deviceTypes,
    deviceStatus,
    orderingRef,
}) => {
    const [t] = useTranslation("tables");
    const types = deviceTypes;
    const status = deviceStatus;

    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        if (checkbox.checked) {
            items.current.addToChosen(e.currentTarget.dataset.idx);
        } else {
            items.current.removeFromChosen(e.currentTarget.dataset.idx);
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShow.map((item) => item.uuid);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = { ...buttonsTB };
        buttons.edit.disabled = items.current.chosen.length == 0;
        buttons.delete.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    const stickyHeaderStyle = {
        position: "sticky",
        top: "169px",
        backgroundColor: "white",
        zIndex: 899,
    };

    return (
        <table className="table table-striped sticky-horizontal">
            <thead>
                <tr>
                    <th key="-1" style={{ width: "26px", ...stickyHeaderStyle }} className="sticky-top border-bottom-sticky">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} styleHeaders={stickyHeaderStyle} />
                </tr>
            </thead>
            <tbody>
                {itemsShow.length ? (
                    itemsShow.map((item) => (
                        <tr key={item.uuid} data-idx={item.uuid} onClick={onClick}>
                            <td>
                                <input
                                    type="checkbox"
                                    name="checkboxContainer"
                                    key={item.uuid}
                                    data-idx={item.uuid}
                                    defaultChecked={
                                        Array.isArray(items.current.chosen) ? items.current.chosen.includes(item.uuid) : false
                                    }
                                    readOnly={true}
                                />
                            </td>
                            <td>{item.uuid}</td>
                            <td>{item.serial}</td>
                            <td>{types[item.type]}</td>
                            <td>{item.config_name}</td>
                            <td>{status[item.status]}</td>
                            <td>{item.asset_uid}</td>
                            <td>{item.group_name}</td>
                            <td>
                                <DateDisplay date={item.last_comm_at} title={true} />
                            </td>
                        </tr>
                    ))
                ) : (
                    <></>
                )}
            </tbody>
        </table>
    );
};

export default TableAssetDevices;
